<template>
  <EventListComponent
      eventRoleList="admin"
  />
</template>

<script>
import EventListComponent from '@/components/Tables/EventListComponent'
import {UserInfo} from '@/controllers/UserInfo';


export default {
  name: 'EventList',
  created() {
  },

  mounted() {

  },

  updated() {

  },

  methods: {},

  computed: {

  },

  components: {
    EventListComponent
  },

  data() {
    return {

    }
  },

  watch: {
}
}
</script>